import * as types from 'containers/starshop/ActionType';
import { createAction } from 'redux-actions';

export const STAR_POINT_REQUEST = createAction(types.STAR_POINT_REQUEST);
export const STAR_POINT_SUCCESS = createAction(types.STAR_POINT_SUCCESS);
export const STAR_POINT_FAILURE = createAction(types.STAR_POINT_FAILURE);

export const PRODUCT_LIST_REQUEST = createAction(types.PRODUCT_LIST_REQUEST);
export const PRODUCT_LIST_SUCCESS = createAction(types.PRODUCT_LIST_SUCCESS);
export const PRODUCT_LIST_FAILURE = createAction(types.PRODUCT_LIST_FAILURE);

export const POINT_USELIST_REQUEST = createAction(types.POINT_USELIST_REQUEST);
export const POINT_USELIST_SUCCESS = createAction(types.POINT_USELIST_SUCCESS);
export const POINT_USELIST_FAILURE = createAction(types.POINT_USELIST_FAILURE);

export const POINT_SAVELIST_REQUEST = createAction(types.POINT_SAVELIST_REQUEST);
export const POINT_SAVELIST_SUCCESS = createAction(types.POINT_SAVELIST_SUCCESS);
export const POINT_SAVELIST_FAILURE = createAction(types.POINT_SAVELIST_FAILURE);

export const SET_GOALS_REQUEST = createAction(types.SET_GOALS_REQUEST);
export const SET_GOALS_SUCCESS = createAction(types.SET_GOALS_SUCCESS);
export const SET_GOALS_FAILURE = createAction(types.SET_GOALS_FAILURE);

export const GET_GOALS_REQUEST = createAction(types.GET_GOALS_REQUEST);
export const GET_GOALS_SUCCESS = createAction(types.GET_GOALS_SUCCESS);
export const GET_GOALS_FAILURE = createAction(types.GET_GOALS_FAILURE);

export const DELETE_TARGET_REQUEST = createAction(types.DELETE_TARGET_REQUEST);
export const DELETE_TARGET_SUCCESS = createAction(types.DELETE_TARGET_SUCCESS);
export const DELETE_TARGET_FAILURE = createAction(types.DELETE_TARGET_FAILURE);

export const EXCHANGE_PRODUCT_REQUEST = createAction(types.EXCHANGE_PRODUCT_REQUEST);
export const EXCHANGE_PRODUCT_SUCCESS = createAction(types.EXCHANGE_PRODUCT_SUCCESS);
export const EXCHANGE_PRODUCT_FAILURE = createAction(types.EXCHANGE_PRODUCT_FAILURE);

export const EXCHANGE_HISTORY_REQUEST = createAction(types.EXCHANGE_HISTORY_REQUEST);
export const EXCHANGE_HISTORY_SUCCESS = createAction(types.EXCHANGE_HISTORY_SUCCESS);
export const EXCHANGE_HISTORY_FAILURE = createAction(types.EXCHANGE_HISTORY_FAILURE);

export const RESEND_PRODUCT_REQUEST = createAction(types.RESEND_PRODUCT_REQUEST);
export const RESEND_PRODUCT_SUCCESS = createAction(types.RESEND_PRODUCT_SUCCESS);
export const RESEND_PRODUCT_FAILURE = createAction(types.RESEND_PRODUCT_FAILURE);

export const PROFILE_PHOTO_REQUEST = createAction(types.PROFILE_PHOTO_REQUEST);
export const PROFILE_PHOTO_SUCCESS = createAction(types.PROFILE_PHOTO_SUCCESS);
export const PROFILE_PHOTO_FAILURE = createAction(types.PROFILE_PHOTO_FAILURE);

export const MMBR_TYPE_REQUEST = createAction(types.MMBR_TYPE_REQUEST);
export const MMBR_TYPE_SUCCESS = createAction(types.MMBR_TYPE_SUCCESS);
export const MMBR_TYPE_FAILURE = createAction(types.MMBR_TYPE_FAILURE);

export const PASS_TARGET_ARRAY = createAction(types.PASS_TARGET_ARRAY);


